import { render, staticRenderFns } from "./MobileRegister.vue?vue&type=template&id=47959cd2&scoped=true"
import script from "./MobileRegister.vue?vue&type=script&lang=js"
export * from "./MobileRegister.vue?vue&type=script&lang=js"
import style0 from "./MobileRegister.vue?vue&type=style&index=0&id=47959cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47959cd2",
  null
  
)

export default component.exports